import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Celula from './Celula';
import React from 'react'
import styled from 'styled-components'

const SortedIcon = styled(ExpandMoreIcon).attrs({
  style: { fontSize: 14 }
})`
  color: gray;
  font-size: 10px;
  ${props => props.oDesc && `
    transform: rotate(180deg);  
  ` }
`

const CelulaHeader = props => {
  const { sort, field, ...oProps } = props;
  const [ k, label ] = field;
  const onClick = sort && sort.set(k);
  return (
    <Celula onClick={onClick} {...oProps} >
      {label}
      {sort && sort.sortBy===k && <SortedIcon oDesc={sort.desc} />}
    </Celula>
  )
}

export default CelulaHeader

